import React, { useEffect, useState, useContext } from 'react';
import BackButton from "../components/back_button";
import ComboboxAutocomplete from '../components/combobox_autocomplete';
import GiustificativiRichiesteNoNull from '../components/giustificativi_richieste_no_null';
import { listOrganizationalUnits } from '../services/api_org_unit';
import Footer from '../components/footer';
import { AuthContext } from '../contexts/auth';
import { Link } from 'wouter';
import PopoverComponentCustom from '../components/popover_component';


const HandledJustifications = () => {
  const prevLocation = '/';
  const [units, setUnits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { token, profile } = useContext(AuthContext);
  const [selectedUnit, setSelectedUnit] = useState(null);

  const isProfileComplete = profile.has_complete_profile;

  useEffect(() => {
    const fetchUnits = async () => {
      setIsLoading(true);
      setIsError(false);

      try {
        const response = await listOrganizationalUnits(token, true, null, 'justifications');
        setUnits(response.data || [] );
      } catch (error) {
        console.error('Error fetching units:', error);
        {(error.response.status !== 402) &&
          setIsError(true);
          setIsLoading(false);
        }
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchUnits();
  }, [token]);

  const handleSelectUnit = (selected) => {
      setSelectedUnit(selected);
  };

  const handleResetUnitSelection = () => {
    setSelectedUnit(null);
  };

  if(isLoading)
    return <div className="relative block w-full rounded-lg  p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2">
        <div role="status">
            <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-800" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
            <span className="sr-only">Loading...</span>
        </div>
        <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
    </div>
  if (isError) return <div>Error loading data</div>;

  return <>
    <div className="min-h-full">
      <PopoverComponentCustom title="Richieste Giustificativi Elaborate" />
      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
              to="/profilo/fatturazione"
              className="text-indigo-600 hover:text-indigo-800 underline"
              >
              cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="mt-10 pb-8">

        <div className="grid md:grid-cols-4 grid-cols-1 items-center mx-5">
          <div className="md:hidden block col-span-1 mb-3">
              <div className="flex justify-end">
                  <BackButton prevLocation={prevLocation} />
              </div>
          </div>
          <div className="col-span-1 justify-end">
              <p className='mr-5 flex lg:justify-end justify-start font-medium text-gray-700 mb-4 md:mb-0 uppercase text-sm'>Unità Organizzativa</p>
          </div>
          <div className="col-span-1 justify-end">
            <ComboboxAutocomplete
              options={units}
              bgActiveColor="bg-indigo-100"
              textActiveColor="text-gray-900"
              placeholder='Seleziona Unità Organizzativa...'
              onChange={handleSelectUnit}
              value={selectedUnit}
              positionOptions='absolute'
            />
          </div>
          <div className="col-span-1 flex items-center ml-10">
            <button
              className={`w-28 mt-2 sm:mt-0 inline-flex justify-center align-middle items-center rounded bg-indigo-600 h-6 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${!selectedUnit ? 'invisible' : ''}`}
              onClick={handleResetUnitSelection}
              disabled={!selectedUnit}
            >
              Reset selezione
            </button>
          </div>
          <div className="hidden md:block md:col-span-1">
              <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                  <div className="flex justify-end">
                      <BackButton prevLocation={prevLocation} />
                  </div>
              </div>
          </div>
        </div>

        <div className="mx-5">
          <GiustificativiRichiesteNoNull selectedUnit={selectedUnit} />  
        </div>

      </main>
      <Footer />
    </div>
  </>;
};

export { HandledJustifications }